module.exports = __webpack_public_path__ + "static/media/key-message-benefits-3840w.dc1ef103.png";